import { useEffect } from "react"

export default function useSelectionBroadcast({
  enableSelection,
  selectedIds,
}) {
  useEffect(() => {
    if (!enableSelection) return

    function broadcast() {
      document.dispatchEvent(
        new CustomEvent("object-list:selection-changed", {
          detail: { selectedIds },
        })
      )
    }

    broadcast()

    function rebroadcast() {
      requestAnimationFrame(broadcast)
    }

    document.addEventListener("turbo:render", rebroadcast)
    document.addEventListener("turbo:frame-render", rebroadcast)
    return () => {
      document.removeEventListener("turbo:render", rebroadcast)
      document.removeEventListener("turbo:frame-render", rebroadcast)
    }
  }, [enableSelection, selectedIds])
}
